import React, {Component} from 'react';
import BannerImg from './../../Images/Banner.jpg';
import BigBannerImg from './../../Images/BigBanner.jpg';
import UpgradeImg from '../smart/UpgradeImg';

class Banner extends Component {
   
    componentDidMount() {
        require("./css/Banner.css");
        
    }
   
    render() {
        return (
            <div className="Banner_Container">
                    <UpgradeImg id="BannerImage" class="BannerImg" alt="Scenic Banner" srcImg={BannerImg} upgrade={BigBannerImg} ready={this.props.pageStatus}></UpgradeImg>
                    <div className="Banner_Title">
                    <h1 className="display-3 font-weight-bold">{this.props.Title? this.props.Title:"Where your health matters"}</h1>
                    </div>
            </div>
            
        );
    }
};

export default Banner;
